<template src="./dashboard.html" />

<script>
import ModulesService from './services/ModulesService';
import setupNotificationsWS from '../../utils/notificationsWebsocket';

export default {
  name: 'Dashboard',
  beforeRouteLeave(to, from, next) {
    if (this.company.itemScriptLoading) return next(false);

    next();
  },
  beforeRouteUpdate(to, from, next) {
    /** Se estiver carregando um módulo, não deixa trocar de pagina */
    if (this.company.itemScriptLoading) return next(false);
    /** Se estiver com um script @legacy aberto, deve fecha-lo */
    if (brain.isLegacyScriptOpen) brain.closeScript();
    next();
  },
  data() {
    return {
      portal: this.$portal,
      company: this.$company,
      user: this.$user,
      brain: this.$brain,
      notifications: this.$notifications,
      listPreviousHeight: 0,
      validatedModules: [],
      websocket: null,
      handlers: {
        notification: this.handleNotification,
        'notification-read': this.handleNotificationRead,
      },
      state: {
        notificationsByModule: {},
        tickets: [],
        websocket: {
          maxRetries: 5,
          retries: 0,
        },
      },
    };
  },
  computed: {
    moduleOpenIcon() {
      if (!this.company.moduleOpen) return;
      return this.company.moduleOpen.icon;
    },
    itemOpenTitle() {
      if (!this.company.itemOpen) return;
      return this.company.itemOpen.title;
    },
    moduleChangeTransitionDuration() {
      if (!this.company.itemOpen) return 0;

      return { enter: 150, leave: 50 };
    },
    hideHeader() {
      return this.company.json.header?.hideHeader;
    },
    moduleItemNotifications() {
      return this.state.notificationsByModule;
    },
  },
  async created() {
    if (!Object.keys(this.notifications.notificationsByModule).length) {
      this.notifications.setupEmptyNotifications();
      await this.notifications.getNotifications();
    }

    this.state.notificationsByModule = this.getUniqueNotifications();

    this.websocket = setupNotificationsWS();

    this.setupWebsocketHandlers();
  },
  async mounted() {
    // this.validatedModules = await ModulesService.getModules();
    await brain.openModalDashboard();
    brain.portal.isLoaded = true;
    /** Fecha os scripts @Legacy */
    // brain.closeScript();
    // this.portal.isLoaded = false;
    // this.user
    //   .loginByToken()
    //   .then(() => {
    //     this.portal.isLoaded = true;
    //   })
    //   .catch(err => {
    //     this.brain.sessionError();
    //   });
  },
  methods: {
    openModule(m, i) {
      window.sessionStorage.tabId = window.tabId;
      brain.openModule({ module: m, item: i });
      // this.company.openModuleItem(m, i);
    },

    isCustomScriptHeader() {
      return _.has(this.company.json, 'script.header');
    },
    isCustomScriptFooter() {
      return _.has(this.company.json, 'script.footer');
    },

    logout() {
      this.user.logout();
      this.$router.push('/');
    },

    checkVisibleEntity() {
      if (!_.has(this.company.json, 'entity')) return false;
      return true;
    },
    checkVisibleComponents() {
      if (!this.user.hasEntity && !_.has(this.company.json, 'entity'))
        return true;
      return this.user.hasEntity;
    },

    hasModulesToShow() {
      const list = this.company.json.module.filter(m => this.checkShowModule(m));
      return list.length > 0;
    },

    checkShowModule(m) {
      /**
       * !!nova funcionalidade adicionada temporariamente!!
       * !!A FUNCIONALIDADE NÃO VAI MODIFICAR A ATUAL REGRA POIS SERÁ RETIRADA!!
       * - NEGA A VISÃO DO MÓDULO QUANDO O USUÁRIO TEM O GRUPO 'nao-ver-${m.id}';
       */
      if (!this.checkVisibleModuleRole(m)) return false;

      if (_.has(m, 'role.moduleNotListed') && m.role.moduleNotListed) return false;

      if (this.company.moduleOpen && this.company.moduleOpen != m) return false;

      if (!_.has(m, 'role.groups') || _.size(m.role.groups) == 0) return true;

      if (
        _.has(m, 'role.groups')
        && _.size(m.role.groups) > 0
        && _.size(this.$user.json.groups) == 0
      )
        return false;

      let isOk = false;

      m.role.groups.forEach(i => {
        if (
          this.$user.json.groups.find(j => j.toLowerCase() == i.toLowerCase())
        )
          isOk = true;
      });
      return isOk;
    },

    /**
     * !!nova funcionalidade adicionada temporariamente!!
     * !!A FUNCIONALIDADE NÃO VAI MODIFICAR A ATUAL REGRA POIS SERÁ RETIRADA!!
     * - NEGA A VISÃO DO MÓDULO QUANDO O USUÁRIO TEM O GRUPO 'nao-ver-${m.id}';
     */
    checkVisibleModuleRole(m) {
      // Verifica "não ver" temporário
      // I use this same function on Header.vue
      const groups = _.get(this.user.json, 'groups');
      if (Array.isArray(groups) && groups.length > 0) {
        const checkId = `module-hide||${m.id}`;
        if (groups.includes(checkId)) return false;
      }
      return true;
    },

    checkShowItem(i) {
      let groups = [];

      if (!i.groups || _.isEmpty(i.groups)) return true;
      groups = i.groups.map(o => o.toLowerCase());

      if (this.$user.json.groups.find(u => groups.includes(u.toLowerCase())))
        return true;

      return false;
    },
    closeScript() {
      // brain.closeScript();
      brain.closeModule();
    },
    /** Transition utils */
    beforeLeave(element) {
      this.listPreviousHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.listPreviousHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },

    setupWebsocketHandlers() {
      this.websocket.onmessage = message => {
        const data = JSON.parse(message.data);
        const handler = this.handlers[data.event];
        if (handler) handler(data);
      };

      this.websocket.onerror = console.info;

      this.websocket.onclose = event => {
        const { wasClean: lostInternetConnection, code } = event;

        const finalTimeoutCode = 1001;

        if (!lostInternetConnection || code === finalTimeoutCode) {
          setTimeout(() => {
            this.state.websocket.retries += 1;
            if (this.state.websocket.retries >= this.state.websocket.maxRetries)
              return;

            this.websocket = setupNotificationsWS();
            this.setupWebsocketHandlers();
          }, 2000);
        }
      };
    },

    async handleNotification(data) {
      const notification = data;

      this.notifications.addNotification(notification);

      this.state.notificationsByModule = this.getUniqueNotifications();

      await this.notifications.notify(notification);
    },

    handleNotificationRead(data) {
      const notification = data;

      this.notifications.removeNotification(notification);

      this.state.notificationsByModule = this.getUniqueNotifications();
    },

    getUniqueNotifications() {
      const notifications = {};

      for (const notificationsByModuleKey of Object.keys(this.notifications.notificationsByModule)) {
        const notificationsByModule = this.notifications.notificationsByModule[notificationsByModuleKey];

        notifications[notificationsByModuleKey] = notificationsByModule.reduce((acc, notification) => {
          if (acc.some(not => not.identifier.includes(notification.uniqueIdentifier)) || notification.read) return acc;

          return [...acc, notification];
        }, []);
      }

      return notifications;
    },
  },
};
</script>

<style scoped src="./dashboard.scss" lang="scss"></style>
